import "./CareerPortalBanner.css";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

function CareerPortalBanner() {

  const navigate = useNavigate();

  return (

    <section className="career_portal_banner">

      <div className="career_portal_content">

        <span className="career_badge">
          Placement Portal
        </span>

        <h2>
          Ready to Start Your Career?
        </h2>

        <p>
          Explore the latest placement opportunities, internships,
          campus drives, and apply to top companies through the EMEI
          Career Portal.
        </p>

      </div>

      <button
        className="career_portal_btn"
        onClick={() => navigate("/career")}
      >
        Explore Careers
        <FaArrowRight />
      </button>

    </section>

  );

}

export default CareerPortalBanner;